import { render, staticRenderFns } from "./radiobox.vue?vue&type=template&id=113d6c60&"
import script from "./radiobox.vue?vue&type=script&lang=js&"
export * from "./radiobox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports